import { Entry, Sys } from "contentful";

export const getId = (entry: { sys: Sys }): string => entry.sys.id;

export const isEntry = <F>(thing: any): thing is Entry<F> =>
  thing?.sys?.type === "Entry";
